import { parse, OrderByNode } from '@jupiterone/query-language-parser';
import { reverse } from '@jupiterone/query-language-reverser';
import { LoadMoreOrderByOptions } from '../types';

export const formatJ1OrderByQuery = (
  query: string,
  newOrderBy?: OrderByNode
) => {
  if (!newOrderBy?.selectors.length) return query;
  const rootQueryNode = parse(query);
  if (!rootQueryNode) return query;

  if (!rootQueryNode.identifier) {
    if (!newOrderBy.selectors[0].sourceIdentifier) {
      newOrderBy.selectors[0].sourceIdentifier = 'x';
    }
    rootQueryNode.identifier = newOrderBy.selectors[0].sourceIdentifier;
  }
  rootQueryNode.orderBy = newOrderBy;
  return reverse(rootQueryNode);
};

type Args = {
  query: string;
  options: LoadMoreOrderByOptions;
};

export const formatJ1OrderByPaginationQuery = ({
  query,
  options: { orderBy },
}: Args) => formatJ1OrderByQuery(query, orderBy);
